import HomeVM from './welcome-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    var data = JSON.parse(node.dataset.coursesData)
    const vm = new Vue(HomeVM);

    vm.bindData(data);
    vm.$mount(node);

    Kadenze.Share.init();
  }
};
